__turbopack_context__.v({
  "copy": "Hero-module__j5d_EG__copy",
  "heroContent": "Hero-module__j5d_EG__heroContent",
  "heroOverlay": "Hero-module__j5d_EG__heroOverlay",
  "heroPanel": "Hero-module__j5d_EG__heroPanel",
  "heroSection": "Hero-module__j5d_EG__heroSection",
  "heroVideo": "Hero-module__j5d_EG__heroVideo",
  "subtitle": "Hero-module__j5d_EG__subtitle",
  "title": "Hero-module__j5d_EG__title",
});
